import React, { useState } from "react"
import { Grid, IconButton } from "@material-ui/core"
import { Link } from "react-router-dom"
import { ActionDialog, Text } from "letalkui"

import {
	ArrowForwardIos as GoToConstructionIcon,
	Delete as DeleteIcon
} from "@material-ui/icons"

import { MoreOptionsMenu } from "@/components"

import useStyles from "@/pages/Admin/Flow/FlowList/FlowListItem/FlowListItemButtons/styles"
import useRoleListActionsStyles from "@/pages/Admin/Role/RoleList/RoleListItem/RoleListActions/styles"

import ErrorHandlerService from "@/services/ErrorHandler"
import { ErrorType } from "@/hooks/useValidation"

import RoleService, { RoleFormattedForList } from "@/services/RoleService"

import { usePermissionStateStore } from "@/store/PermissionState"
import { PERMISSION_DENIED_MESSAGE } from "@/components/PermissionGate/BasePermissionGate"

type RoleListActionsProps = {
	onDelete: (roleId: number) => void
	role: Pick<RoleFormattedForList, "id" | "name" | "type">
}

const RoleListActions: React.FC<RoleListActionsProps> = (props) => {
	const {
		onDelete,
		role
	} = props

	const roleEditorPath = `/admin/attendance/roles/${role.id}`
	const isSystemRole = role.type === "system"

	const { checkPermission } = usePermissionStateStore()
	const canDeleteRole = checkPermission("role", "delete")

	const classes = useStyles()
	const roleListActionsClasses = useRoleListActionsStyles()

	const [openDeleteRoleDialog, setOpenDeleteRoleDialog] = useState(false)

	const handleOpenDeleteRoleDialog = () => {
		setOpenDeleteRoleDialog(true)
	}

	const handleCloseDeleteRoleDialog = () => {
		setOpenDeleteRoleDialog(false)
	}

	const handleDeleteRole = async () => {
		try {
			await RoleService.delete(role.id)
			onDelete(role.id)
		} catch (error) {
			ErrorHandlerService.handle(error as ErrorType)
		}
	}

	const optionsMenu = () => {
		const deleteDisabledTooltip = isSystemRole
			? "Cargos padrão do sistema não podem ser deletados"
			: PERMISSION_DENIED_MESSAGE

		const options = [
			{
				title: "Excluir cargo",
				icon: <DeleteIcon />,
				showIcon: true,
				disabled: isSystemRole || !canDeleteRole,
				disabledTooltip: deleteDisabledTooltip,
				onClick: handleOpenDeleteRoleDialog
			}
		]

		return options
	}

	const renderEditButton = () => {
		return (
			<Link
				to={roleEditorPath}
				className={roleListActionsClasses.linkWithoutDecoration}
				target="_blank"
			>
				<IconButton className={classes.listItemButton}>
					<GoToConstructionIcon className={classes.editIcon} />
				</IconButton>
			</Link>
		)
	}

	const renderMoreOptionsMenu = () => {
		return <MoreOptionsMenu options={optionsMenu()} />
	}

	return (
		<Grid container spacing={1} justifyContent="flex-end">
			<Grid item md={6} lg="auto">
				<Grid container alignItems="center" justifyContent="flex-end">
					{renderEditButton()}
				</Grid>
			</Grid>

			<Grid item md={6} lg="auto">
				<Grid className={classes.listItemMoreOptions}>
					{renderMoreOptionsMenu()}
				</Grid>
			</Grid>

			<ActionDialog
				title="Excluir cargo"
				open={openDeleteRoleDialog}
				onClose={handleCloseDeleteRoleDialog}
				onSave={handleDeleteRole}
				saveButtonLabel="Excluir"
				cancelButtonLabel="Cancelar"
				shouldHaveFullWidth={true}
				maxWidthSize="sm"
			>
				<Grid container>
					<Grid item xs={12}>
						<Text.Body type="default">
							Você tem certeza que deseja excluir o cargo <strong>{role.name}</strong>?
						</Text.Body>
					</Grid>
				</Grid>
			</ActionDialog>
		</Grid>
	)
}

export default RoleListActions
